import React, { useState, useEffect } from "react";
import "./Blog.css";
import axios from "axios";
import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import CONFIG from "../src/config"; // Import the config file
import SEO from "./SeoHelmet";
import metaConfig from "./SeoComponent";
import { useLocation } from "react-router-dom";
import EvntFullslider from "./EventCarousel";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function Blog() {
  const location = useLocation(); // Get the current location (path)

  const meta = metaConfig.eventall;

  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    // Fetch data from the backend
    axios
      .get(`${CONFIG.BASE_URL}/api/images/images`) // Replace with your API URL
      .then((response) => {
        setBlogs(response.data); // Assuming response data is an array of blog objects
      })
      .catch((error) => {
        console.error("Error fetching blog data:", error);
      });
  }, []);
  const [currentDate, setCurrentDate] = useState("");

  useEffect(() => {
    const updateDate = () => {
      const date = new Date();
      const options = { day: "numeric", month: "short", year: "numeric" };
      const formattedDate = date.toLocaleDateString("en-US", options);
      setCurrentDate(formattedDate);
    };
    updateDate();
    const interval = setInterval(updateDate, 1000);

    return () => clearInterval(interval);
  }, []);

  const itemsPerSlide = 4;

  // Group blogs into sets of 4
  const groupedBlogs = [];
  for (let i = 0; i < blogs.length; i += itemsPerSlide) {
    groupedBlogs.push(blogs.slice(i, i + itemsPerSlide));
  }

  return (
    <div>
      <SEO {...meta} />

      {/* <!-- Navbar & Hero Start --> */}
      <div class="container-fluid position-relative p-0">
        <div class="w-100 me-3 top_head">
          <div class="top_head align-items-center"></div>
        </div>
        <Header />
      </div>
      {/* <!-- Navbar & Hero End -->
<!-- Header Start --> */}
      <div class="container-fluid events_inn bg-breadcrumb">
        <div class="container text-center py-5" style={{ maxWidth: "900px" }}>
          <ol
            class="breadcrumb d-flex justify-content-center mb-0 wow fadeInDown"
            data-wow-delay="0.3s"
          ></ol>
          <h4
            class="text-white display-4 mb-4 wow fadeInDown"
            data-wow-delay="0.1s"
          >
            Join KTIG Family
          </h4>
        </div>
      </div>

      {/* <!-- Header End --> */}

      {/* <!-- Modal Search Start --> */}
      <div
        class="modal fade"
        id="searchModal"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-fullscreen">
          <div class="modal-content rounded-0">
            <div class="col-lg-12 m-auto modal-header justify-content-lg-end">
              <button
                type="button"
                class="btn-close justify-content-lg-end text-white"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="col-lg-9 m-auto modal-header align-items-center text-center">
              <h4
                class="modal-title mb-0 m-auto text-white"
                id="exampleModalLabel"
              >
                Search by keyword
              </h4>
            </div>
            <div class="modal-body align-items-center">
              <div class="input-group w-75 mx-auto d-flex">
                <input
                  type="search"
                  class="form-control p-3"
                  placeholder="keywords"
                  aria-describedby="search-icon-1"
                />
                <span
                  id="search-icon-1"
                  class="input-group-text btn border p-3"
                >
                  <i class="fa fa-search text-white"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid innercontain event_pages bloginnerpage  blog py-5">
        <div className="container">
          <div
            className="text-center mt-0 mx-auto wow fadeInUp"
            data-wow-delay="0.2s"
            style={{ maxWidth: "800px" }}
          >
            <h1 className="display-3 text-white text-center mb-3">
              KTIG Events and Celebrations
            </h1>
          </div>
          <EvntFullslider carouselItems={blogs} />
        </div>
        <div></div>
      </div>

      <Footer />
      <a
        href="#"
        class="btn btn-secondary btn-lg-square rounded-circle back-to-top"
      >
        <i class="fa fa-arrow-up"></i>
      </a>
    </div>
  );
}

export default Blog;
